//Seguridad de URL para blindar que no entren sin estar logueados
// Es un PrivateRoute mas potente, (RoleRoute = PrivateRoute + Verificación de Rol.)


import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getHomeRouteByRole } from "../utils/rutas";
import { revokeUnacknowledgedServerSession, buildLoginRedirectTarget } from "../utils/browserSessionGuard";
import { isSessionAcknowledged } from "../utils/sessionGate";
import { clearSessionKeys } from "../utils/sessionKeys";
import { fetchSessionStatus } from "../utils/sessionAuth";

const RoleRoute = ({ allowedRoles = [], requiredPermissions = [], children }) => {
  const [loading, setLoading] = useState(true);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [redirectTo, setRedirectTo] = useState(null);
  const location = useLocation();

  const rolesString = JSON.stringify(allowedRoles);
  const permissionsString = JSON.stringify(requiredPermissions);
  const loginRedirectTarget = buildLoginRedirectTarget(location.pathname, location.search) || "/login";

  useEffect(() => {
    let cancelled = false;

    const verifyAuth = async () => {
      setLoading(true);
      setRedirectTo(null);

      try {
        if (!isSessionAcknowledged()) {
          await revokeUnacknowledgedServerSession();
          if (!cancelled) {
            setIsAuthorized(false);
            setRedirectTo(loginRedirectTarget);
          }
          return;
        }

        const session = await fetchSessionStatus();

        if (cancelled) return;

        if (!session.authenticated) {
          clearSessionKeys();
          setIsAuthorized(false);
          setRedirectTo(loginRedirectTarget);
          return;
        }

        const currentRoles = JSON.parse(rolesString);
        const currentPermissions = JSON.parse(permissionsString);
        const rol = session.usuario?.rol;
        const permisos = session.usuario?.permisos || {};

        if (
          (rol && currentRoles.includes(rol)) ||
          currentPermissions.some((permission) => permisos[permission] === true)
        ) {
          setIsAuthorized(true);
          return;
        }

        if (rol) {
          setIsAuthorized(false);
          setRedirectTo(getHomeRouteByRole(rol));
          return;
        }

        setIsAuthorized(false);
        setRedirectTo(loginRedirectTarget);
      } catch (_) {
        if (!cancelled) {
          setIsAuthorized(false);
          setRedirectTo(loginRedirectTarget);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    verifyAuth();
    return () => {
      cancelled = true;
    };
  }, [rolesString, permissionsString, loginRedirectTarget]);

  if (loading) {
    return <div style={{ display: 'flex', justifyContent: 'center', padding: '2rem' }}>Verificando permisos...</div>;
  }

  if (!isAuthorized && redirectTo) {
    return <Navigate to={redirectTo} replace />;
  }

  if (!isAuthorized) {
    if (process.env.NODE_ENV === "development") {
      console.warn("[RoleRoute] Acceso no autorizado. Redirigiendo a /login.", { allowedRoles });
    } else {
      console.warn("[RoleRoute] Acceso no autorizado. Redirigiendo a /login.");
    }
    return <Navigate to={loginRedirectTarget} replace />;
  }

  return children;
};

export default RoleRoute;
